import { render } from "./IndexButtonContent.vue?vue&type=template&id=f61b33a2&scoped=true&ts=true"
import script from "./IndexButtonContent.vue?vue&type=script&lang=ts"
export * from "./IndexButtonContent.vue?vue&type=script&lang=ts"

import "./IndexButtonContent.vue?vue&type=style&index=0&id=f61b33a2&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61b33a2"]])

export default __exports__